<template>
  <div class="container-fluid">
    <apexchart
      :key="chartKey"
      height="250"
      :options="chartOptions"
      :series="chartOptions.series"
    ></apexchart>
  </div>
</template>

<script>
export default {
  name: 'ProfitSettlementChart',
  data() {
    return {
      chartKey: 0,
      chartOptions: {
        chart: {
          type: 'bar',
          horizontal: true,
          toolbar: {
            show: false,
          },
          fontFamily: 'IRANSans, Tahoma, Arial',
          width: '100%',
        },
        title: {
          text: 'وضعیت تسویه سود',
          align: 'center',
          style: {
            fontSize: '14px',
            fontWeight: 'bold',
            color: '#5a4a42',
          },
        },
        colors: ['#435EBE', '#21AE89', '#FDA700', '#fd397a', '#5CB0FF', '#694467'],
        plotOptions: {
          bar: {
            horizontal: true,
            barHeight: '60%',
            dataLabels: {
              position: 'center',
            },
            distributed: true,
          },
        },
        dataLabels: {
          enabled: true,
          formatter: function (val) {
            return val.toLocaleString('en-US');
          },
          style: {
            fontSize: '12px',
            colors: ['#333'],
          },
        },
        xaxis: {
          categories: [],
          min: 0,
          max: 0,
          tickAmount: 4,
          labels: {
            formatter: function (val) {
              return val.toLocaleString('en-US');
            },
            style: {
              fontSize: '11px',
              colors: '#333',
            },
          },
        },
        yaxis: {
          labels: {
            offsetX: -140,
            align: 'right',
            maxWidth: 220,
            style: {
              direction: 'rtl',
              fontSize: '12px',
              colors: '#333',
            },
          },
        },
        
        series: [
          {
            name: 'مقدار',
            data: [],
          },
        ],
        tooltip: {
          y: {
            formatter: function (val) {
              return val.toLocaleString('en-US') + ' ریال';
            },
          },
        },
        legend: {
          show: false,
        },
      },
    };
  },
  methods: {
    roundUpToNiceNumber(value) {
      if (value === 0) return 100000000;

      const magnitude = Math.pow(10, Math.floor(Math.log10(value)));
      const normalized = value / magnitude;

      const niceNumbers = [1, 1.5, 2, 2.5, 3, 4, 4.5, 5, 6, 7, 8, 9, 10];
      let rounded = niceNumbers.find((num) => num >= normalized) || 10;

      return rounded * magnitude;
    },
    GetProfitSettlementData() {
      var DataAxiosRow = {
        ArryfildValue: '',
        Method: 'Post',
        Action: 'AllCharts/TasSod',
        Token: this.$session.get('TokenNetPa'),
      };

      const formData = new FormData();
      formData.append('BnpCashazaId', this.$session.get('UserInfoNetPa').bnpCashDBtblAzaId);
      DataAxiosRow.ArryfildValue = formData;

      this.$PostFormData(DataAxiosRow)
        .then((response) => {
          console.log('Profit Settlement Response:', response);
          if (response.success && response.data && response.data.length > 0) {
            const data = response.data[0];
            console.log('Profit Settlement Data:', data);

            const categories = [
              'مجموع سود تخصیص یافته',
              'پرداخت سود على الحساب قبلي',
              'مانده سود قابل پرداخت',
            ];

            const values = [
              data.majsod || 0, // مجموع سود تخصیص یافته
              data.sodalalhesab || 0, // پرداخت سود علی الحساب
              data.mandesod || 0, // مانده سود قابل پرداخت
            ];

            const maxValue = Math.max(...values);
            const roundedMax = maxValue > 0 ? this.roundUpToNiceNumber(maxValue) : 1000000000;

            this.chartOptions.xaxis.categories = categories;
            this.chartOptions.series[0].data = values;
            this.chartOptions.xaxis.max = roundedMax;
            this.chartOptions.xaxis.tickAmount = 4;
            this.chartKey++;
          } else {
            console.warn('Invalid response structure:', response);
          }
        })
        .catch((error) => {
          console.error('Error fetching profit settlement data:', error);
        });
    },
  },
  created() {
    this.GetProfitSettlementData();
  },
};
</script>

<style scoped>
.container-fluid {
  padding: 10px;
  background-color: #fff;
  border: 1px solid #d0d0d0;
  border-radius: 4px;
}
</style>

